import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from "@angular/router";
import {OAuthService} from "angular-oauth2-oidc";

import {parametresClient, RetournerCheminsApplication, VAL_MODE_ROUTEUR} from "../../../val-definitions-communes-lib/src/public-api";
import {authentificationConfiguration} from "./authentification.config";
import {ValAppSettingsService} from "../../../val-ammon-services/val-app-settings-lib/src/public-api";

//Gère l’autorisation de l’ouverture d’une page
export const valAuthetificationGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
{
  const oAuthService: OAuthService = inject (OAuthService);
  const appSettingsService: ValAppSettingsService = inject (ValAppSettingsService);
  const router: Router = inject (Router);
  const cheminConnexion: string = RetournerCheminsApplication ().connexion;
  const modeRouteur: boolean = inject (VAL_MODE_ROUTEUR);

  try
  {
    sessionStorage.removeItem ("route_cible");

    await oAuthService.loadDiscoveryDocumentAndTryLogin ();

    if (oAuthService.hasValidAccessToken ())
      return true;

    //Session configurée mais jeton absent ou expiré. En mode routeur, retour à la saisie du code client plutôt
    //qu’une page vide ; les autres applications gardent leur refus
    if (!modeRouteur)
      return false;

    //Code client et lien d’entrée SSO transmis, comme sans session configurée
    sessionStorage.setItem ("route_cible", state.url);
    return router.createUrlTree ([cheminConnexion], {queryParams: {codeClient: route.queryParamMap.get ("codeClient"), sso: route.queryParamMap.get ("sso")}});
  }
  catch (erreur)
  {
    let codeClient = route.queryParamMap.get ("codeClient") ?? "";
    //Transmis à la page de connexion (lien d’entrée SSO) ; absent, il n’apparaît pas dans l’URL
    const sso = route.queryParamMap.get ("sso");

    if (!codeClient)
      codeClient = sessionStorage.getItem ("code_client") || "";

    if (codeClient)
    {
      parametresClient.code = codeClient;

      let issuer: string = appSettingsService.Configuration.OpenIdConnect.Authority;
      issuer += "/realms/" + codeClient;

      authentificationConfiguration.issuer = issuer;
      authentificationConfiguration.clientId = "ammon-plateforme-ui";

      oAuthService.configure (authentificationConfiguration);
      oAuthService.setupAutomaticSilentRefresh ();

      await oAuthService.loadDiscoveryDocumentAndTryLogin ();

      if (oAuthService.hasValidAccessToken ()) 
      {
        return true;
      }
      else 
      {
        sessionStorage.setItem ("route_cible", state.url);
        return router.createUrlTree([cheminConnexion], {queryParams: {codeClient, sso}});
      }
    }
    else
    {
      sessionStorage.setItem ("route_cible", state.url);
      return router.createUrlTree([cheminConnexion], {queryParams: {sso}});
    }
  }
};